import isiVisibility from '../patterns/isi-visibility.js';
import isiScrollAndToggle from '../patterns/isi-scrollAndToggle';

export default () => {
  const isi = document.getElementById('main-isi');
  if (isi) {
    isiVisibility();
    isiScrollAndToggle();

    //Disabling transition in IE because it's looking wonky.
    const ua = window.navigator.userAgent;
    const isInIE = ua.indexOf("MSIE ");
    if (isInIE > 0) {
      document.getElementById('sticky-isi').style.setProperty('transition', 'none');
    }
  } else {
    return;
  }
}